import { Form, Switch } from "antd";
import classNames from "classnames";
import { useTranslation } from "react-i18next";
import { DirectFlightOnlyIcon } from "src/assets/Icons";

export default function DirectFlightComponent() {
  const { t } = useTranslation();
  const form = Form.useFormInstance();
  const value = Form.useWatch("directFlight",form);
  return (
    <div className="flex w-full items-center justify-between gap-2 md:w-min md:justify-end md:justify-center">
      <div className="text-font-minimal flex items-center gap-2">
        <DirectFlightOnlyIcon className="w-5! h-5!" />
        <div className="whitespace-nowrap font-semibold ">{t("Flights.search.directFlight")}</div>
      </div>
        <Form.Item className="m-0! items-center justify-center md:flex md:w-min" name="directFlight" valuePropName="checked">
          <Switch className={classNames(value ? "bg-background-primary!" : "bg-background-subtle")}/>
        </Form.Item>
    </div>
  );
}
